<template>
  <div>
    <div class="text-center my-2 my-sm-6 my-md-12">
      <LinkLogo class="mx-auto" />
    </div>
    <v-sheet class="d-flex justify-space-between mx-auto mb-2 align-center main-container" max-width="1000">
      <ChangeLocale />
    </v-sheet>
    <v-sheet max-width="1000" class="py-4 py-md-8 py-lg-12 px-2 px-md-6 px-lg-12 mx-auto mb-6" id="bordered-sheet">
      <v-sheet max-width="800" class="mx-auto">
        <router-view></router-view>
      </v-sheet>
    </v-sheet>
    <Footer />
  </div>
</template>

<script>
import LinkLogo from "@/components/common/LinkLogo"
import ChangeLocale from "@/components/common/ChangeLocale"
import Footer from "@/components/common/Footer"
export default {
  name: "Collectes",
  components: {
    LinkLogo,
    ChangeLocale,
    Footer
  }
}
</script>

<style scoped>
#app.v-application {
  background: #ecedee no-repeat top;
  background-image: url(https://www.diabete.qc.ca/wp-content/themes/diabete.qc.ca/dist/images/default/default_banner.jpg);
}
</style>